import { Container } from './styled';
import { FormLayout } from 'views/components';
import { fileActions } from 'core/File';
import { patientActions } from 'core/Patient';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
    Folder,
    NewFolder
} from './components';
import React, { useEffect } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const PatientFiles = () => {

    const dispatch = useDispatch();
    const { id } = useParams();
    const { t } = useTranslation();

    const {
        folders,
        loading
    } = useSelector('file');
    const {
        selected: {
            first_name,
            last_name
        } = {}
    } = useSelector('patient');

    useEffect(() => {
        if (!!id) {
            const patientId = Number(id);
            dispatch(fileActions.getFileFolders(patientId));
            dispatch(patientActions.getPatientData(patientId));
        }
    }, [id]);

    return (
        <FormLayout
            goBackName={ t('Volver') }
            goBackTo={ `${ t('/pacientes/historial') }/${ id }` }
            loading={ loading }
            title={ `${ ('Archivos del paciente') } ${ !!first_name && !!last_name ? `- ${ last_name }, ${ first_name }` : '' }` }
        >
            <Container>
                {
                    folders.map(folder => (
                        <Folder
                            data={ folder }
                            key={ folder.id }
                        />
                    ))
                }
                <NewFolder />
            </Container>
        </FormLayout>
    );
};

export default PatientFiles;
